import { render, staticRenderFns } from "./GeneralSettingHRM.vue?vue&type=template&id=7860ed2c&"
import script from "./GeneralSettingHRM.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports